module.exports = __webpack_public_path__ + "img/menual03.f1269685.svg";